<template>
    <div class="switch_container">
      <label class="label" style="display: inline;">{{ inputName }}</label>
      <label class="switch">
        <input type="checkbox" @click="selectInput()">
        <span class="slider"></span>
      </label>
      <!-- <div
        class="choice"
        @click="selectInput()"
        :class="selected ? 'selected' : ''"
      >
      </div> -->
      <p class="help is-danger" style="margin-bottom: 20px;" v-if="field.error">{{ field.error }}</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "SmallCheckbox",
    model() {
      return { value: "", error: "", typed: false };
    },
    props: {
      inputField: Object,
      inputName: String,
      inputType: String
    },
    data() {
      return {
        field: this.inputField,
        selected: false
      };
    },
    methods: {
      modified() {
        this.field.typed = true;
        this.setValue(this.selected)
        this.validate();
      },
      validate() {
        // console.log("validating");
        this.field.error = null;
        // if (!this.field.value && this.inputType == "required") {
        //   this.field.error = "";
        // }
        return this.field.error == null;
      },
      setValue(s) {
        this.field.value = s;
        // this.modified();
      },
      selectInput() {
        this.selected = !this.selected;
        this.modified();
        this.validate();
      }
    }
  };
  </script>
  <style scoped>
  /* .field {
    padding: 20px 20px;
    background: #edf0f3;
    border-radius: 5px;
    margin: 12px 0px;
  }
  .choice {
    padding: 10px;
    transition: all 0.5s;
    margin: 20px 0px !important;
    cursor: pointer;
    border: 1px solid #0a9dff;
    border-radius: 5px;
  }
  .selected {
    background: #f0f4ff;
  } */

/* copied CSS */
  .switch {
      position: relative;
      /* display: inline-block; */
      width: 39px;
      height: 20px;
      float: right;
    }

    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      transition: 0.4s;
      border-radius: 34px;
    }

    .slider:before {
      position: absolute;
      content: "";
      /* height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px; */

      height: 16px;
      width: 16px;
      left: 3px;
      bottom: 2px;

      background-color: white;
      transition: 0.4s;
      border-radius: 50%;
    }

    input:checked + .slider {
      background-color: #28A745;
    }

    input:checked + .slider:before {
      transform: translateX(16px);
    }
    .switch_container{
      margin-bottom: 1rem;
    }
  </style>
  